import { Card, Table, Typography } from "antd";
import moment from "moment/moment";
import { useLocalStorage } from "usehooks-ts";
import numeral from "numeral";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const TransactionsTable = () => {
    const [user] = useLocalStorage("user", null);
    const { t } = useTranslation();

    const dataColumns = [
        {
            title: t("profile.transactions_card.columns.description"),
            dataIndex: "description",
            key: "description",
        },
        {
            title: t("profile.transactions_card.columns.amount"),
            dataIndex: "amount",
            key: "amount",
            render: (_, record) => {
                if (record.amount < 0) {
                    record.amount = record.amount * -1;
                }
                let label_amount = numeral(record?.amount / 100).format("0,0.00");
                return <Text>€{label_amount} </Text>;
            },
        },
        {
            title: t("profile.transactions_card.columns.date"),
            dataIndex: "creation_date",
            key: "creation_date",
            responsive: ["md"],
            render: (date) => moment(date).format("DD/MM/YYYY"),
        },
    ];

    return (
        <>
            <Card
                style={{
                    width: "100vw",
                    maxWidth: "100%",
                }}
                title={t("profile.transactions_card.title")}>
                <Table
                    scroll={{ x: 400 }}
                    columns={dataColumns}
                    dataSource={user?.wallet?.transactions.sort((a, b) =>
                        a.creation_date < b.creation_date ? 1 : -1
                    )}
                    pagination={{
                        defaultPageSize: 10,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50", "100"]
                    }}
                    style={{ marginTop: "10px", width: "100%" }}
                />
            </Card>
        </>
    );
};

export { TransactionsTable };
